/**
 * Concept 1 mega menu: swap the preview pane (image, title, count, link)
 * when hovering a sub-collection link. Uses event delegation so it keeps
 * working even if the header menu re-renders or moves items into the
 * overflow ("More") menu.
 */
(function () {
  var DEFAULTS = new WeakMap();

  function stateFromLink(link) {
    return {
      img: link.getAttribute('data-mm-img') || '',
      title: link.getAttribute('data-mm-title') || '',
      count: link.getAttribute('data-mm-count') || '',
      url: link.getAttribute('data-mm-url') || '',
    };
  }

  function defaultState(preview) {
    if (DEFAULTS.has(preview)) return DEFAULTS.get(preview);
    var state = {
      img: preview.getAttribute('data-mm-default-img') || '',
      title: preview.getAttribute('data-mm-default-title') || '',
      count: preview.getAttribute('data-mm-default-count') || '',
      url: preview.getAttribute('data-mm-default-url') || '',
    };
    DEFAULTS.set(preview, state);
    return state;
  }

  function apply(preview, state) {
    if (!state) return;

    var media = preview.querySelector('[data-mm-media]');
    var img = preview.querySelector('[data-mm-img-el]');
    var titleEl = preview.querySelector('[data-mm-pane-title]');
    var countEl = preview.querySelector('[data-mm-pane-count]');
    var paneLink = preview.querySelector('[data-mm-pane]');

    if (img && media) {
      if (state.img) {
        if (img.getAttribute('src') !== state.img) {
          img.style.opacity = '0';
          var loader = new Image();
          loader.onload = function () {
            img.src = state.img;
            media.classList.remove('mm-preview__media--empty');
            img.style.opacity = '1';
          };
          loader.src = state.img;
        } else {
          media.classList.remove('mm-preview__media--empty');
          img.style.opacity = '1';
        }
      } else {
        media.classList.add('mm-preview__media--empty');
      }
    }

    if (titleEl) titleEl.textContent = state.title;
    if (countEl) countEl.textContent = state.count ? state.count + ' modèles' : '';
    if (paneLink && state.url) paneLink.setAttribute('href', state.url);
  }

  document.addEventListener('mouseover', function (event) {
    var target = event.target;
    var link = target && target.closest ? target.closest('.mm-preview__link') : null;
    if (!link) return;
    var preview = link.closest('[data-mm-preview]');
    if (!preview) return;
    defaultState(preview);
    apply(preview, stateFromLink(link));
  });

  document.addEventListener('mouseout', function (event) {
    var target = event.target;
    var link = target && target.closest ? target.closest('.mm-preview__link') : null;
    if (!link) return;
    var preview = link.closest('[data-mm-preview]');
    if (!preview) return;

    // Le menu groupé (Concept A) utilise .mm-preview__cols, l'ancien .mm-preview__list.
    // Sans ce second sélecteur, passer d'un lien à l'autre remettait le panneau à
    // son état par défaut entre chaque survol — d'où un clignotement de l'image.
    var related = event.relatedTarget;
    var list = preview.querySelector('.mm-preview__cols') || preview.querySelector('.mm-preview__list');
    if (related && list && list.contains(related)) return;

    apply(preview, defaultState(preview));
  });
})();
